module.exports = __webpack_public_path__ + "static/media/sm_linkedin.ee5ea991.svg";